import _ from 'lodash';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

// jsdom and older browsers lack matchMedia; absence is treated as "motion allowed" so the default
// smooth/animated experience is preserved wherever the query can't be evaluated.
const getPrefersReducedMotion = () => {
  if (typeof window === 'undefined' || !_.isFunction(window.matchMedia)) {
    return false;
  }

  return !!window.matchMedia(REDUCED_MOTION_QUERY).matches;
};

export const getScrollBehavior = () => (getPrefersReducedMotion() ? 'auto' : 'smooth');
